import React from 'react';
import CloseButton from '@/components/common/CloseButton';

export default function EntityDetailsHeader({
  children,
  onClose,
}: {
  children: React.ReactNode;
  onClose: () => void;
}) {
  return (
    <>
      <CloseButton
        onClick={onClose}
        className="absolute right-2 top-2"
        data-testid="entity-details-close-button"
      />
      <div className="mb-5">{children}</div>
    </>
  );
}
